var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-white" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "py-2 flex" }, [
        _vm.back
          ? _c(
              "button",
              { on: { click: _vm.goBack } },
              [
                _c("font-awesome-icon", {
                  staticClass: "text-gray mr-4",
                  attrs: { icon: "arrow-left", size: "lg" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Go back")])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h2", { staticClass: "m-0 capitalize" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto" }, [_vm._t("actions")], 2)
      ]),
      _vm._v(" "),
      _c("nav", [_vm._t("navigation")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }